import { Progress } from './progress/progress.model';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { AuthGuard } from './../route-guards/auth/auth.guard';
import { RegionsListGuard } from './login/regions-list-guard'

import { ClientListComponent } from './client/list/list.component';
import { ClientGuard } from './client/client.guard';
import { ClientListGuard } from './client/client-list.guard';

import { CampaignListComponent } from './campaign/list/list.component';
import { CampaignGuard } from './campaign/campaign.guard';
import { CampaignListGuard } from './campaign/campaign-list.guard';
import { CampaignFormComponent } from './campaign/form/form.component';

import { ProviderListComponent } from './provider/list/list.component';
import { ProviderGuard } from './provider/provider.guard';
import { ProviderListGuard } from './provider/provider-list.guard';
import { UsersListGuard } from './users/users-list.guard';
import { OutletListGuard } from './outlet/outlet-list.guard';
import { UsersGuard } from './users/users.guard';
import { OutletGuard } from './outlet/outlet.guard';
import { PartyListGuard } from './provider/party-list.guard';
import { ProviderFormComponent } from './provider/form/form.component';

import { ProgressListComponent } from './progress/list/list.component';
import { CampaignTransactionsComponent } from './campaign/campaign-transactions/campaign-transactions.component';
import { ProgressListGuard } from './progress/progress-list.guard';
import { ProgressFormComponent } from './progress/detail/detail.component';
import { ProgressGuard } from './progress/progress.guard';

import { ListComponent } from './apac-detail/list/list.component';
import { DetailComponent } from './apac-detail/detail/detail.component';

import { SendTestProfileFormComponent } from './send-test-profile/form/form.component';
import { UsersListComponent } from './users/list/list.component';
import { UsersFormComponent } from './users/form/form.component';
import { OutletListComponent } from './outlet/list/list.component';
import { OutletFormComponent } from './outlet/form/form.component';
import { DashreportListComponent } from './dashreport/list/list.component';




const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'clients',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: ClientListComponent,
        resolve: {
          clients: ClientListGuard
        }
      }
    ]
  },
  {
    path: 'campaigns',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: CampaignListComponent,
        resolve: {
          campaigns: CampaignListGuard
        }
      },
      {
        path: 'add',
        component: CampaignFormComponent,
        resolve: {
          parties: PartyListGuard,
          providers: ProviderListGuard
        }
      },
      {
        path: 'edit',
        component: CampaignFormComponent,
        resolve: {
          campaign: CampaignGuard,
          parties: PartyListGuard,
          providers: ProviderListGuard
        }
      }
    ]
  },
  {
    path: 'providers',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: ProviderListComponent,
        resolve: {
          providers: ProviderListGuard
        }
      },
      {
        path: 'add',
        component: ProviderFormComponent,
        resolve: {
          parties: PartyListGuard
        }
      },
      {
        path: 'edit',
        component: ProviderFormComponent,
        resolve: {
          provider: ProviderGuard,
          parties: PartyListGuard
        }
      }
    ]
  },
  {
    path: 'progress',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: ProgressListComponent,
        resolve: {
          progress: ProgressListGuard
        }
      },
      {
        path: 'detail',
        component: ProgressFormComponent,
        resolve: {
          progress: ProgressGuard,
        }
      }
    ]
  },
  {
    path: 'volumes',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: ListComponent
      },
      {
        path: 'detail',
        component: DetailComponent
      }
    ]
  },
  {
    path: 'transactions',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: CampaignTransactionsComponent
      }
    ]
  },
  {
    path: 'sendtestprofile',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: SendTestProfileFormComponent
      }
    ]
  },
  {
    path: 'users',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: UsersListComponent,
        resolve: {
          users: UsersListGuard
        }
      },
      {
        path: 'add',
        component: UsersFormComponent,
        resolve: {
          campaigns: CampaignListGuard
        }
      },
      {
        path: 'edit',
        component: UsersFormComponent,
        resolve: {
          campaigns: CampaignListGuard,
          user: UsersGuard
        }
      },
    ]
  },
  {
    path: 'outlet',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: OutletListComponent,
        resolve: {
          outlet: OutletListGuard
        }
      },
      {
        path: 'add',
        component: OutletFormComponent,
        resolve: {
          campaigns: CampaignListGuard,
        }
      },
      {
        path: 'edit',
        component: OutletFormComponent,
        resolve: {
          campaigns: CampaignListGuard,
          outlet: OutletGuard,
        }
      },
    ]
  },
  {
    path: 'dashreport',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: DashreportListComponent,
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/app-routing.module.ts